// This function animates the bowl slider on scroll
// It reveals the bowl image from left to right as the user scrolls
// through the section
const animateBowlSlider = (container: HTMLElement): void => {
  const bowl = document.getElementById('fresh-food__raw-bowl')
  if (!bowl) throw new Error('No fresh-food__raw-bowl found')
  const border = document.getElementById('fresh-food__meal-slider__border')
  if (!border) return

  const offset = 375
  const scrollPosition = window.scrollY - (container.offsetTop - offset)
  const scrollPercentage =
    Math.min(Math.max(scrollPosition / container.clientHeight, 0), 1) * 100
  if (scrollPercentage > 10 && scrollPercentage < 95) {
    // eslint-disable-next-line i18next/no-literal-string
    bowl.style.clipPath = `inset(0 ${scrollPercentage}% 0 0)`
    // We need webkitClipPath here so that this will replace the
    // scrollPercentage value for the meal slider to work successfully in Safari
    // 12.1 and older browsers
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: no any
    // eslint-disable-next-line i18next/no-literal-string
    bowl.style.webkitClipPath = `inset(0 ${scrollPercentage}% 0 0)`
    border.style.right = `${scrollPercentage}%`
    border.style.opacity = '1'
  } else {
    border.style.opacity = '0'
  }
}

const initBowlSliderAnimation = (): void => {
  const container = document.getElementById('fresh-food__meal-slider')
  if (!container) return
  const animateBowlSliderOnScroll = (): void => {
    window.requestAnimationFrame((): void => animateBowlSlider(container))
  }

  const handleScroll = (entries: Array<IntersectionObserverEntry>): void => {
    entries.forEach((entry: IntersectionObserverEntry): void => {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', animateBowlSliderOnScroll)
      } else {
        window.removeEventListener('scroll', animateBowlSliderOnScroll)
      }
    })
  }

  const observer = new IntersectionObserver(handleScroll)
  observer.observe(container)
}

export { initBowlSliderAnimation }
